import { useEffect, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  useGetSubCompanyInfoList,
  useGoToCompany,
} from "../../api/CompaniesApi";
import LoadingSpinner from "../../shared-components/LoadingSpinner";
import Pagination from "../../shared-components/Pagination";
import Table from "../Table";

type Props = {
  inputUUID?: string;
};

const SubCompanyTable = ({ inputUUID }: Props) => {
  const { goToSubCompany } = useGoToCompany();

  const {
    isLoading: loadingCompanies,
    data: companyData,
    mutate: getCompanyFetchList,
    reset,
  } = useGetSubCompanyInfoList();
  const pageSize = 25;
  const { companyId: companyUUID } = useParams();
  const { search } = useLocation();
  const [total, setTotal] = useState(0);
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const [name, setSearch] = useState(searchParams.get("search") || "");
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (companyUUID) reset();
  }, [companyUUID, reset]);

  useEffect(() => {
    setSearch(searchParams.get("search")?.trim() || "");

    if (searchParams.get("page")) {
      setPage(Number(searchParams.get("page")));
    }
  }, [searchParams]);

  useEffect(() => {
    if (!companyUUID) return;
    getCompanyFetchList({
      size: pageSize,
      page: page,
      company_uuid: companyUUID,
      search: name,
    });
  }, [getCompanyFetchList, name, page, companyUUID]);

  useEffect(() => {
    setTotal(companyData?.total ?? 1);
  }, [companyData]);

  const tableHeader = ["SUB COMPANY", "CHECK TYPES"];
  function handleClick(subCompanyUUID: string) {
    goToSubCompany(companyUUID ?? "", subCompanyUUID, "behavior-kits");
  }

  useEffect(() => {
    if (!inputUUID || !companyUUID) return;
    getCompanyFetchList({
      size: pageSize,
      page: page,
      company_uuid: companyUUID,
    });
  }, [companyUUID, getCompanyFetchList, inputUUID, page]);

  if (loadingCompanies) return <LoadingSpinner />;
  return (
    <div>
      {companyData?.items && (
        <Table
          isLoading={loadingCompanies}
          header={tableHeader}
          data={companyData.items}
          onClick={handleClick}
          showSubcompanies={false}
        />
      )}
      {total > 0 && (
        <Pagination
          pageSize={pageSize}
          currentPage={page}
          totalCount={total}
          search={name}
        />
      )}
    </div>
  );
};

export default SubCompanyTable;
